/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import CustomTextField from '../common/custom-components/customTextField';
import CustomCheckBox from '../common/custom-components/customCheckBox';
import CustomTextAreaField from '../common/custom-components/customTextAreaField';
import InfoMessageBar from '../common/info-message/info-message';
import Typography from '@material-ui/core/Typography';
import './customer-info.css';
import { stateCodes } from '../../constants/states-constants';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import CancelDialog from '../common/cancel-dialog/cancel-dialog';
import {
  required,
  maxLength5,
  zipCode,
  bondAmount,
  bondNo,
  bondAmountValue,
  formatAmount,
  maskAccount,
} from '../../constants/constants';
import { CustomSelectField } from '../common/custom-components/customDropDown';
import Link from '@material-ui/core/Link';
import Title from '../common/custom-components/customTitleHeader';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import {
  checkPrevious,
  checkForPrevious,
  getDueDate,
  checkDiff,
  isCommentsValid,
} from '../../utils/validationUtils';
const CustomerInfoForm = props => {
  console.log('customer-info.jsx', props.invalid);
  const {
    errors,
    handleSubmit,
    customerInfo,
    insuranceInfo,
    invalid,
    submitting,
    pristine,
    insurCompNotfound,
    insurNotfound,
    handleCustomerInfoBack,
    handleCustomerInfoCancel,
    depositAmt,
    depositQuote,
    depositAmtDiff,
    insurAddr,
    comments,
    selectedInsu,
    insurcompanyName,
  } = props;
  let diff = checkDiff(
    depositAmtDiff,
    depositAmt,
    depositQuote,
    props.customerInfo.depositAmtDiff,
  );
  let DueDate = getDueDate(props.customerInfo.depositDueDate, moment);

  return (
    <div className="container " style={{ backgroundColor: '#F7F8F9' }}>
      <div className="row">
        <div className="col-md-6 offset-md-3 col-xs-12">
          <form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <div className="container">
              <Card boxShadow={3} style={{ marginBottom: 40 }}>
                <CardContent>
                  <div>
                    {customerInfo.bondNumber !== undefined && (
                      <div className="header1">
                        <Title text="Application Review Form" />
                      </div>
                    )}
                    {customerInfo.bondNumber === undefined && (
                      <div className="header1">
                        <Title text="Application Form" />
                      </div>
                    )}
                  </div>
                  {errors && (
                    <InfoMessageBar variant="error" message={errors} />
                  )}

                  {comments !== null && (
                    <InfoMessageBar
                      id="2"
                      variant="warning"
                      icColor="warningIc"
                      variant="warning"
                      message={comments}
                    />
                  )}
                  <div className="content-Header-pad">
                    <Typography component="h6" variant="h5">
                      Account Information
                    </Typography>
                  </div>
                  <Divider />
                  <div className="rowpad">
                    <Typography component="h2" variant="h5">
                      Company Name :
                    </Typography>
                    {customerInfo.companyName !== undefined && (
                      <Typography color="textSecondary" variant="h6">
                        {customerInfo.companyName}
                      </Typography>
                    )}
                  </div>
                  <div className="rowpad">
                    <Typography component="h2" variant="h5">
                      Account Number :
                    </Typography>
                    {customerInfo.billAccount !== undefined && (
                      <Typography color="textSecondary" variant="h6">
                        {maskAccount(customerInfo.billAccount, 5)}
                      </Typography>
                    )}
                  </div>
                  <div className="rowpad">
                    <Typography component="h2" variant="h5">
                      TaxID/SSN :
                    </Typography>
                    {customerInfo.taxId !== undefined && (
                      <Typography color="textSecondary" variant="h6">
                        {maskAccount(customerInfo.taxId, 4)}
                      </Typography>
                    )}
                  </div>
                  <div className="rowpad">
                    <Typography component="h2" variant="h5">
                      Deposit Due Date :
                    </Typography>
                    <Typography color="textSecondary" variant="h6">
                      {DueDate}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
              <Card boxShadow={3}>
                <CardContent>
                  <div className="content-Header-pad">
                    <Typography component="h6" variant="h5">
                      Surety Bond Information
                    </Typography>
                  </div>
                  <Divider />
                  {diff && (
                    <InfoMessageBar
                      id="1"
                      icColor="warningIc"
                      variant="warning"
                      message={`The Bond Amount  you have entered does not match the amount on Deposit Certificate. Please check the box below if this is correct. `}
                    />
                  )}
                  <Field
                    className="form-control form-control-lg TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="bondNo"
                    symbol="Bond  #"
                    placeholder="Bond  #"
                    required
                    type="text"
                    variant="outlined"
                    validate={[required, bondNo]}
                  />
                  <Field
                    className="form-control form-control-lg TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    symbol="$ Bond Amount"
                    name="depositAmt"
                    placeholder="Bond Amount"
                    format={formatAmount}
                    required
                    type="text"
                    variant="outlined"
                    validate={[required, bondAmountValue, bondAmount]}
                  />
                  {diff && (
                    <div className="check-pad">
                      <Field
                        className="form-control form-control-lg TextField-border-radius"
                        component={CustomCheckBox}
                        label="Proceed with Bond Amount as entered."
                        name="diffAmt"
                        required
                        type="checkBox"
                        validate={[required]}
                      />
                    </div>
                  )}
                  <Field
                    className="form-control form-control-lg TextField-border-radius"
                    color="primary"
                    component={CustomTextAreaField}
                    name="reasons"
                    symbol="Bond  #"
                    rowsMin={2}
                    placeholder=" Any message to Deposit Admin"
                    required
                    type="text"
                    variant="outlined"
                  />
                  {customerInfo.insuranceCompanyName !== undefined && (
                    <div className="rowpad">
                      <Typography component="h2" variant="h5">
                        Insurance Company Selected :
                      </Typography>
                      {customerInfo.insuranceCompanyName !== undefined && (
                        <Typography color="textSecondary" variant="h6">
                          {customerInfo.insuranceCompanyName}
                        </Typography>
                      )}
                    </div>
                  )}

                  {!insurNotfound && insuranceInfo && insuranceInfo.length > 0 && (
                    <React.Fragment>
                      {customerInfo.insuranceCompanyName !== undefined &&
                        checkPrevious(
                          customerInfo,
                          selectedInsu,
                          insurcompanyName,
                        ) && (
                          <InfoMessageBar
                            id="1"
                            icColor="errorIc"
                            variant="error"
                            message={`The insurance company cannot be the same as previously selected. Please make another selection. `}
                          />
                        )}
                      <Field
                        className="TextField-border-radius"
                        component={CustomSelectField}
                        name="insurComp"
                        symbol="Select your Insurance Company"
                        type="select"
                        variant="outlined"
                        validate={[required]}
                      >
                        <option value="">Select your Insurance Company</option>
                        {insuranceInfo.map(item => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </Field>
                    </React.Fragment>
                  )}
                  {!insurNotfound &&
                    insurAddr &&
                    insurAddr.length === 1 &&
                    insurAddr.map(item => (
                      <React.Fragment key={item.id}>
                        <div className="rowpad">
                          <Typography component="h6" variant="h6">
                            Please confirm Insurance Company Address&nbsp;:
                          </Typography>
                        </div>
                        <div className="check-pad">
                          <Field
                            className="form-control form-control-lg TextField-border-radius"
                            key={item.id}
                            component={CustomCheckBox}
                            label={
                              item.insuranceCompanyStrAddr +
                              '' +
                              item.insuranceCompanyCity +
                              '' +
                              item.insuranceCompanyState +
                              '' +
                              item.insuranceCompanyZipCode
                            }
                            name="insurAddrCheck"
                            required
                            type="checkBox"
                            validate={[required]}
                          />
                        </div>
                      </React.Fragment>
                    ))}

                  {!insurNotfound && insurAddr && insurAddr.length > 1 && (
                    <React.Fragment>
                      <Field
                        className="TextField-border-radius"
                        component={CustomSelectField}
                        name="insurCompAddr1"
                        symbol="Select your Insurance Company Address"
                        type="select"
                        variant="outlined"
                        validate={[required]}
                        disabled={checkPrevious(
                          customerInfo,
                          selectedInsu,
                          insurcompanyName,
                        )}
                      >
                        <option value="">
                          Select your Insurance Company Address
                        </option>
                        {insurAddr.map(item => (
                          <option
                            key={item.id}
                            value={item.insuranceCompanyStrAddr}
                          >
                            {item.insuranceCompanyStrAddr}
                            &nbsp;{item.insuranceCompanyCity}&nbsp;
                            {item.insuranceCompanyState}&nbsp;
                            {item.insuranceCompanyZipCode}
                          </option>
                        ))}
                      </Field>
                    </React.Fragment>
                  )}

                  {insurNotfound && (
                    <React.Fragment>
                      <div className="rowpad">
                        <Typography component="h4" variant="h6">
                          Choose Insurance Company From The List
                        </Typography>
                      </div>
                      <div className="row link-margin">
                        <Link
                          component="button"
                          variant="body2"
                          onClick={insurCompNotfound}
                          style={{ fontSize: 20, fontFamily: 'Arial' }}
                        >
                          See the Insurance Company List
                        </Link>
                      </div>
                    </React.Fragment>
                  )}

                  {!insurNotfound && (
                    <React.Fragment>
                      <div className="rowpad">
                        <Typography component="h4" variant="h6">
                          Insurance Company Not Found?
                        </Typography>
                      </div>
                      <div className="row link-margin">
                        <Link
                          component="button"
                          variant="body2"
                          onClick={insurCompNotfound}
                          style={{ fontSize: 20, fontFamily: 'Arial' }}
                        >
                          Add Your Own
                        </Link>
                      </div>
                    </React.Fragment>
                  )}
                  {insurNotfound && (
                    <React.Fragment>
                      <InfoMessageBar
                        variant="info"
                        icColor="infoIc"
                        message={`The Insurance Company selected must be rated C (per Weiss Ratings, Inc.) or higher for FPL’s acceptance. 
                    In addition, this rating is monitored to ensure that this minimum rating is maintained throughout the life of your bond. `}
                      />
                      {customerInfo.insuranceCompanyName !== undefined &&
                        checkPrevious(
                          customerInfo,
                          selectedInsu,
                          insurcompanyName,
                        ) && (
                          <InfoMessageBar
                            id="1"
                            icColor="errorIc"
                            variant="error"
                            message={`The insurance company cannot be the same as previously selected. Please make another selection. `}
                          />
                        )}
                      <Field
                        className="form-control form-control-lg TextField-border-radius"
                        color="primary"
                        component={CustomTextField}
                        name="insurcompanyName"
                        symbol="Insurance&nbsp;CompanyName&nbsp;"
                        placeholder="Insurance&nbsp;CompanyName"
                        required
                        type="text"
                        validate={[required]}
                        variant="outlined"
                      />
                      <Field
                        className="form-control form-control-lg TextField-border-radius"
                        color="primary"
                        component={CustomTextField}
                        name="insurStr"
                        symbol="Address Line 1"
                        placeholder="Address Line 1"
                        required
                        type="text"
                        validate={[required]}
                        variant="outlined"
                      />
                      <Field
                        className="form-control form-control-lg TextField-border-radius"
                        color="primary"
                        component={CustomTextField}
                        name="insurStr2"
                        symbol="Address Line 2"
                        placeholder="Address Line 2"
                        type="text"
                        variant="outlined"
                      />
                      <Field
                        className="form-control form-control-lg TextField-border-radius"
                        color="primary"
                        component={CustomTextField}
                        name="insurCity"
                        symbol="City"
                        placeholder="City"
                        required
                        type="text"
                        validate={[required]}
                        variant="outlined"
                      />
                      <Field
                        className="TextField-border-radius"
                        component={CustomSelectField}
                        label=""
                        name="insurState"
                        type="select"
                        variant="outlined"
                      >
                        {stateCodes.map(item => (
                          <option
                            key={item.abbreviation}
                            value={item.abbreviation}
                          >
                            {item.name}
                          </option>
                        ))}
                      </Field>
                      <Field
                        className="TextField-border-radius"
                        color="primary"
                        component={CustomTextField}
                        name="insurZipcode"
                        symbol="ZipCode"
                        placeholder="ZipCode"
                        required
                        type="text"
                        validate={[required, maxLength5, zipCode]}
                        variant="outlined"
                      />
                    </React.Fragment>
                  )}
                  {(customerInfo.appStatus === 'PENDING_CORRECTIONS' ||
                    customerInfo.appStatus === 'REJECTED') && (
                    <div className="check-pad">
                      <Field
                        component={CustomCheckBox}
                        label="Please confirm the corrections are made as suggested."
                        name="correctionsMade"
                        required
                        type="checkBox"
                        disabled={
                          checkPrevious(
                            customerInfo,
                            selectedInsu,
                            insurcompanyName,
                          ) || checkForPrevious(customerInfo, insurcompanyName)
                        }
                        validate={[required]}
                      />
                    </div>
                  )}

                  <div />
                  <div className="botton1-group">
                    {customerInfo.bondNumber !== undefined && (
                      <React.Fragment>
                        {' '}
                        <div className="link-pad">
                          <Link
                            component="button"
                            variant="h6"
                            color="primary"
                            style={{ padding: '15px 50px' }}
                            value={props.customerInfo.id}
                            onClick={props.handleAgentHomeCancel}
                          >
                            Delete Application
                          </Link>
                        </div>
                        <CancelDialog
                          open={props.modalOpen}
                          delete={props.handleAppDelete}
                          close={props.handleModalClose}
                          content=""
                        />
                      </React.Fragment>
                    )}
                    <Button
                      disabled={
                        invalid ||
                        submitting ||
                        pristine ||
                        checkPrevious(
                          customerInfo,
                          selectedInsu,
                          insurcompanyName,
                        ) ||
                        checkForPrevious(customerInfo, insurcompanyName)
                      }
                      type="submit"
                      color="primary"
                      variant="contained"
                      style={{ fontSize: 16 }}
                      fullWidth
                    >
                      CONTINUE
                    </Button>

                    {customerInfo.bondNumber !== undefined && (
                      <div className="link-pad">
                        <Link
                          component="button"
                          variant="h6"
                          color="primary"
                          onClick={handleCustomerInfoBack}
                          value={'false'}
                        >
                          BACK
                        </Link>
                      </div>
                    )}
                    {customerInfo.bondNumber === undefined && (
                      <div className="link-pad">
                        <Link
                          component="button"
                          variant="h6"
                          color="primary"
                          onClick={handleCustomerInfoCancel}
                        >
                          CANCEL
                        </Link>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
CustomerInfoForm.propTypes = {
  customerInfo: PropTypes.shape({
    id: PropTypes.number,
    companyName: PropTypes.string,
    billAccount: PropTypes.number,
    taxId: PropTypes.number,
    street: PropTypes.string,
    streetline2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.number,
    depositDueDate: PropTypes.string,
    depositQuoteAmt: PropTypes.number,
    bondNumber: PropTypes.string,
    appStatus: PropTypes.string,
    depositAmtDiff: PropTypes.bool,
    insuranceCompanyName: PropTypes.string,
    insuranceCompanyStrAddr: PropTypes.string,
    insuranceCompanyCity: PropTypes.string,
    insuranceCompanyState: PropTypes.string,
    insuranceCompanyZipCode: PropTypes.string,
  }),
  insuranceInfo: PropTypes.arrayOf(
    PropTypes.shape({
      insuranceCompanyName: PropTypes.string,
      address: PropTypes.string,
      length: PropTypes.func,
      map: PropTypes.func,
    }),
  ),
  insurAddr: PropTypes.arrayOf(
    PropTypes.shape({
      insuranceCompanyName: PropTypes.string,
      address: PropTypes.string,
      length: PropTypes.func,
      map: PropTypes.func,
    }),
  ),
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
  insurCompNotfound: PropTypes.func,
  insurNotfound: PropTypes.bool,
  handleChange: PropTypes.func,
  depositAmtDiff: PropTypes.bool,
  handleCustomerInfoBack: PropTypes.func,
  depositAmt: PropTypes.string,
  depositQuote: PropTypes.string,
  handleModalClose: PropTypes.func,
  handleAppDelete: PropTypes.func,
  handleAgentHomeCancel: PropTypes.func,
  modalOpen: PropTypes.bool,
  comments: PropTypes.array,
  selectedInsu: PropTypes.string,
};
export default reduxForm({
  form: 'customerInfoForm',
  enableReinitialize: true,
  fields: ['depositAmt'],
})(CustomerInfoForm);
